import React, { createContext, useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { login, logout, verifyAuth } from '../actions/userActions'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch()
  const { user, token, isAuthenticated, loading, error } = useSelector(state => state.user)
  
  useEffect(() => {
    // Verify authentication on app load
    dispatch(verifyAuth())
  }, [dispatch])
  
  const loginUser = async (email, password) => {
    return await dispatch(login(email, password))
  }
  
  const logoutUser = () => {
    dispatch(logout())
  }
  
  const value = {
    user,
    token,
    isAuthenticated,
    loading,
    error,
    login: loginUser,
    logout: logoutUser
  }
  
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}